 <!--2nd Policy Details-->
 <div class="tab-pane" id="tabs-2" role="tabpanel">
    <div class="row mt-2 mb-3 m-0">
      <div class="col-lg-12 col-sm-12 col-12 p-0">
          <span class="heading_cls">Policy</span>                   
      </div>
      <div class="col-lg-10 col-sm-12 col-12 p-lg-0">
      <div class="row mt-3 ">
          <div class="col-lg-2 col-sm-3 col-12 text-right">
            <label class="label_cls">
                Policy Period:
            </label>
          </div>
          <div class="col-lg-10 col-sm-9 col-12 pl-lg-0 edit_cls">
              <label class="data_cls" *ngIf="!isEditControls?.PolicyPeriod">
                {{(PolicyDetailsList?.policyStartDate | date:"MM/dd/yyyy") }} - {{PolicyDetailsList?.policyEndDate | date:"MM/dd/yyyy"}}
              </label>
              <div class="data_cls" style="float: left;" *ngIf="isEditControls?.PolicyPeriod">
                <p-calendar class="mb-1 date_cntrl mr-2" [showIcon]="true" inputId="icon" [(ngModel)]="PolicyDetailsList.policyStartDate"></p-calendar>
                <p-calendar class="mb-1" [showIcon]="true" inputId="icon" [(ngModel)]="PolicyDetailsList.policyEndDate"></p-calendar>
                <!-- <input type="text" class="data_cls form-control mb-1" [(ngModel)]="PolicyDetailsList.policyStartDate">
                <input type="text" class="data_cls form-control mb-1" [(ngModel)]="PolicyDetailsList.policyEndDate"> -->
              </div>

              <a class="ml-3" *ngIf="PolicyDetailsList?.policyStartDate || PolicyDetailsList?.policyEndDate">
                <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.PolicyPeriod ===undefined || !isEditControls?.PolicyPeriod" aria-hidden="true" (click)="editTheDetails('PolicyPeriod')"></i>
                <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.PolicyPeriod" aria-hidden="true" (click)="skipEdit('PolicyPeriod')"></i>
              </a>
              <!-- <a href="#" class="ml-3">
                <i class="fa fa-pencil-square-o" aria-hidden="true" 
                *ngIf="PolicyDetailsList?.policyStartDate || PolicyDetailsList?.policyEndDate"></i></a> -->

          </div>                        
        </div>
        <div class="row mt-3 mb-2">
          <div class="col-lg-2 col-sm-3 col-12 text-right">
            <label class="label_cls">
                Jobsite Limit:
            </label>
          </div>
          <div class="col-lg-10 col-sm-9 col-12 pl-lg-0 edit_cls">
              <label class="data_cls" *ngIf="!isEditControls?.Jobsitelimit">
                {{PolicyDetailsList?.jobsiteLimit | currency}}
              </label>
              <div class="data_joblimit_value" *ngIf="isEditControls?.Jobsitelimit">
                <input type="number" class="data_input_edit form-control" [(ngModel)]="PolicyDetailsList.jobsiteLimit">
              </div>
              <a class="ml-3" *ngIf="PolicyDetailsList?.jobsiteLimit">
                <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Jobsitelimit ===undefined || !isEditControls?.Jobsitelimit" aria-hidden="true" (click)="editTheDetails('Jobsitelimit')"></i>
                <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.Jobsitelimit" aria-hidden="true" (click)="skipEdit('Jobsitelimit')"></i>
              </a>
              <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.jobsiteLimit"></i></a> -->
          </div>                        
        </div>
        <div class="row mt-3 mb-2">
          <div class="col-lg-2 col-sm-3 col-12 text-right ">
            <label class="label_cls">
                Deductible:
            </label>
          </div>
          <div class="col-lg-10 col-sm-9 col-12 pl-lg-0 edit_cls">
              <label class="data_cls" *ngIf="!isEditControls?.Deductible">
                {{PolicyDetailsList?.foodAndEarthquake?.deductible | currency}}
              </label>
              <div class="data_cls" *ngIf="isEditControls?.Deductible">
                <input type="number" class="data_cls form-control" [(ngModel)]="PolicyDetailsList.foodAndEarthquake.deductible">
              </div>
              <a class="ml-3" *ngIf="PolicyDetailsList?.foodAndEarthquake?.deductible">
                <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Deductible ===undefined || !isEditControls?.Deductible" aria-hidden="true" (click)="editTheDetails('Deductible')"></i>
                <i class="fa fa fa-check-square-o" *ngIf="isEditControls?.Deductible" aria-hidden="true" (click)="skipEdit('Deductible')"></i>
              </a>
              <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.foodAndEarthquake?.deductible"></i></a> -->
          </div>                        
        </div>
      </div>
   </div>

   <div class="row mt-2 mb-3 m-0">
    <div class="col-lg-12 col-sm-12 col-12 p-0">
        <span class="heading_cls">Flood & Earthquake</span>                   
    </div>
    <div class="col-lg-10 col-sm-12 col-12 p-lg-0">
    <div class="row mt-3 ">
        <div class="col-lg-2 col-sm-3 col-12 text-right">
          <label class="label_cls">
              Flood:
          </label>
        </div>
        <div class="col-lg-10 col-sm-9 col-12 pl-lg-0 edit_cls">
            <label class="data_cls" *ngIf="!isEditControls?.FloodEarthquake">
              {{PolicyDetailsList?.foodAndEarthquake?.isFloodCovered == true ? 'Covered' : 'Not Covered'}}
            </label>
            <div class="data_cls" style="float: left;" *ngIf="isEditControls?.FloodEarthquake">
              <input type="text" class="data_input_edit form-control" [(ngModel)]="PolicyDetailsList.foodAndEarthquake.isFloodCovered">
            </div>
            <a class="ml-3" *ngIf="PolicyDetailsList?.foodAndEarthquake?.isFloodCovered">
              <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.FloodEarthquake ===undefined || !isEditControls?.FloodEarthquake" aria-hidden="true" (click)="editTheDetails('FloodEarthquake')"></i>
              <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.FloodEarthquake" aria-hidden="true" (click)="skipEdit('FloodEarthquake')"></i>
            </a>
            <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.foodAndEarthquake?.isFloodCovered"></i></a> -->
        </div>                        
      </div>

      <div class="row mt-0">
          <div class="offset-lg-1 col-md-5 border_top_1 pt-3">
              <div class="row">
                  <div class="col-md-5 col-lg-5 col-12 text-right">
                    <label class="label_cls">
                      Limit:
                  </label>
                  </div>
                  <div class="col-md-7 col-lg-7 col-12 pl-lg-0 edit_cls">
                    <label class="data_cls amtpolicylbl" *ngIf="!isEditControls?.Limit">
                      {{PolicyDetailsList?.foodAndEarthquake?.limit | currency}}
                    </label>
                    <div class="data_joblimit_value" style="float: left; width:80%;" *ngIf="isEditControls?.Limit">
                      <input type="number" class="data_cls form-control" [(ngModel)]="PolicyDetailsList.foodAndEarthquake.limit">
                    </div>
                    <a class="ml-3" *ngIf="PolicyDetailsList?.foodAndEarthquake?.limit">
                      <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Limit ===undefined || !isEditControls?.Limit" aria-hidden="true" (click)="editTheDetails('Limit')"></i>
                      <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.Limit" aria-hidden="true" (click)="skipEdit('Limit')"></i>
                    </a>
                    <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.foodAndEarthquake?.limit"></i></a> -->
                  </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-5 col-lg-5 col-12 text-right">
                  <label class="label_cls">
                    Deductible:
                </label>
                </div>
                <div class="col-md-7 col-lg-7 col-12 pl-lg-0 edit_cls">
                  <label class="data_cls amtpolicylbl" *ngIf="!isEditControls?.Deductible">
                    {{PolicyDetailsList?.foodAndEarthquake?.deductible | currency}}
                  </label>
                  <div class="data_cls" *ngIf="isEditControls?.Deductible">
                    <input type="number" class="data_cls form-control" [(ngModel)]="PolicyDetailsList.foodAndEarthquake.Deductible">
                  </div>
                  <a class="ml-3" *ngIf="PolicyDetailsList?.foodAndEarthquake?.Deductible">
                    <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Deductible ===undefined || !isEditControls?.Deductible" aria-hidden="true" (click)="editTheDetails('Deductible')"></i>
                    <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.Deductible" aria-hidden="true" (click)="skipEdit('Deductible')"></i>
                  </a>
                  <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.foodAndEarthquake?.deductible"></i></a> -->
                </div>
            </div>
          </div>
      </div>
     
      <div class="row mt-4 mb-2 ">
        <div class="col-lg-2 col-sm-3 col-12 text-right ">
          <label class="label_cls">
              Earthquake:
          </label>
        </div>
        <div class="col-lg-10 col-sm-9 col-12 pl-lg-0 edit_cls">
            <label class="data_cls" *ngIf="!isEditControls?.Earthquake">
              {{PolicyDetailsList?.foodAndEarthquake?.isEarthquakeCovered == true ? 'Covered' : 'Not Covered'}}
            </label>
            <div class="data_cls" *ngIf="isEditControls?.Earthquake">
              <input type="text" class="data_cls form-control" [(ngModel)]="PolicyDetailsList.foodAndEarthquake.isEarthquakeCovered">
        </div>                        
            <a class="ml-3" *ngIf="PolicyDetailsList?.foodAndEarthquake?.Deductible">
              <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Earthquake ===undefined || !isEditControls?.Earthquake" aria-hidden="true" (click)="editTheDetails('Earthquake')"></i>
              <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.Earthquake" aria-hidden="true" (click)="skipEdit('Earthquake')"></i>
            </a>
            <!-- <a href="#" class="ml-3"><i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="PolicyDetailsList?.foodAndEarthquake?.isEarthquakeCovered"></i></a> -->
      </div>
    </div>
 </div>
 </div>
 <div class="row mt-3">
  <div class="col-md-12 ">
    <div class="col-md-12 evdbtn border_top_1 pt-3 text-right">
      <button pButton type="button" class="btn btn-primary mt-0 mr-0 cancel_btn font-600" label="Cancel" (click)="skipAllEdit()"></button>
    </div>
  </div>
</div>
